<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>

<template>
  <div class="create-user-component">
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <vx-tooltip :text="$t('Labels.Edit')" class="float-right" color="primary" >
        <vs-button v-show="license.status == 'C' || license.status == 'A'" @click="edit(uuid)" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-edit" icon-pack="feather" type="filled"></vs-button>
      </vx-tooltip>
      <vx-tooltip :text="$t('Labels.Report')" class="float-right" color="primary" >
        <vs-button  @click="goToReport()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="assignment" type="filled"></vs-button>
      </vx-tooltip>
      <h4>{{$t('Labels.Detail')}}</h4>
      <table cellspancing="5" class="border-separate mt-5">
        <tbody>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Client')}}</td>
            <td class=" px-2 py-1">{{license.company.name}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Start')}}</td>
            <td class=" px-2 py-1">{{license.begin_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Expire')}}</td>
            <td class=" px-2 py-1">{{license.expire_at}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.PublicKey')}}</td>
            <td class=" px-2 py-1">{{license.publicKey}}  
              <vs-button @click="requestPassword('key')" class="ml-2 float-left" color="primary" type="filled" icon="icon-download-cloud" icon-pack="feather" ></vs-button>
              </td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Status')}}</td>
            <td class=" px-2 py-1">
              <span v-if="license.status == 'C'" class="p-2 rounded bg-success text-white">{{$t('Labels.Created')}}</span>
              <span v-if="license.status == 'A'" class="p-2 rounded bg-success text-white">{{$t('Labels.Asigned')}}</span>
              <span v-if="license.status == 'Ac'" class="p-2 rounded bg-success text-white">{{$t('Labels.Active')}}</span>
              <span v-if="license.status == 'I'" class="p-2 rounded bg-grey text-white">{{$t('Labels.Inactive')}}</span>
              <span v-if="license.status == 'E'" class="p-2 rounded bg-red text-white">{{$t('Labels.Expired')}}</span>
            </td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Validity')}}</td>
            <td class=" px-2 py-1">{{getValidity(license.begin_at,license.expire_at)}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.TimeToExpire')}}</td>
            <td class=" px-2 py-1">{{timeToExpire(license.expire_at)}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
            <td class=" px-2 py-1">{{license.created_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
            <td class=" px-2 py-1">{{license.user!= null ?license.user.first_name + ' ' + license.user.last_name:''}}</td>
          </tr>
        </tbody>
      </table>
    </vx-card>
    <div class="w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">
        <h4>{{$t('Labels.Assignments')}}</h4>
      <table cellspancing="5" class="border-separate mt-5" v-if="license">
        <tbody>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.Device',2)}}</td>
            <td class=" px-2 py-1">{{license.count_devices == null ? '0' :license.count_devices}}</td>
            <td class=" px-2 py-1">
              <vs-button @click="goDevices()" type="border">{{$t("Labels.GoTo") + ' ' + $tc("Labels.Device",2)}}</vs-button>
            </td>
            <td class=" px-2 py-1">
              <vs-button v-show="license.status == 'C' || license.status == 'A'" @click="goAssign()" type="border">{{$t("Labels.Assign") + ' ' + $tc("Labels.Device",2)}}</vs-button>
            </td>
            <td class=" px-2 py-1">
              <vs-button v-show="license.status == 'C' || license.status == 'A'" @click="requestPassword('finish')" type="border">{{$t("Labels.Close") + ' ' + $t('Labels.Assignments')}}</vs-button>
            </td>
          </tr>
        </tbody>
      </table>
    </vx-card>
    </div>
    <!--<vx-card class="grid-view-item mb-base overflow-hidden">
      <h4>{{$tc('Labels.Device',2)}}</h4>
      <vs-table v-if="license.devices" ref="table" :data="license.devices">
        <template slot-scope="{data}">
          <tbody>
            <tr @click="goToDetail(item.uuid)" class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in license.devices" >
              <listItem
                :value="item.serie"
                :description="$t('Labels.Serie')"
                img="alias"
              ></listItem>
              <listItem
                :value="item.puerto"
                :description="$t('Labels.Port')"
                img="alias"
              ></listItem>
              <listItem
                :value="item.appId"
                :description="$t('Labels.App',1)"
                img="alias"
              ></listItem>
              <listItem
                :value="item.profile"
                :description="$t('Labels.Profile')"
                img="alias"
              ></listItem>
              <listItem
                :value="item.status"
                :description="$t('Labels.Status')"
                img="alias"
              ></listItem>
              <listItem
                :value="item.user"
                :description="$t('Labels.Creator')"
                img="alias"
              ></listItem>
            </tr>
          </tbody>
        </template>
      </vs-table> 
    </vx-card>-->
  </div>
</template>
<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import listItem from '@/components/listItem/listItem.vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'
import axios from 'axios'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

export default {
  components: {
    listItem
  },
  data () {
    return {
      license:{},
      uuid: this.$route.params.uuid,
      callFinish: false,
      callaDownload: false
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `licenses/${this.uuid}`,
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.license = response.data.data
        if (this.license.applications_records != null) this.logData = this.response.applications_records
      })
    },
    edit (uuid) {
      window.location.href = `/licenses/${  this.uuid  }/update`
    },
    requestPassword (action) {
      if (action == 'finish') {
        this.callFinish = true
        this.callaDownload = false
      } else {
        this.callFinish = false
        this.callaDownload = true
      }
      globalPassActions.show()
    },
    async doFinish(){
      const params = {
        url: `licenses/${this.uuid}/finish_assign`,
        method: 'PUT',
        params: {}
      }
      await request(params).then(response => {
        
      })    
    },
    doCopy () {
      const App = this
      this.$copyText(this.license.publicKey).then(function (e) {
        App.onCopy()
      }, function (e) {
        App.onError()
      })
    },
    onCopy () {
      this.$vs.notify({
        title:'¡Copiado!',
        position:'top-center',
        time:8000,
        color:'success',
        icon:'done'
      })
    },
    onError () {
      this.$vs.notify({
        title:'¡Error!',
        position:'top-center',
        time:8000,
        color:'danger',
        icon:'warning'
      })
    },
    goToDetail (uuid) {
      window.location.href = `/devices/${uuid}`
    },
    goAssign () {
      window.location.href = `/licenses/${this.uuid}/assign`
    },
    goToReport () {
      window.location.href = `/licenses/${this.uuid}/report`
    },
    getValidity (start, expire) {
      const s = this.$dayjs(start)
      const e = this.$dayjs(expire)

      return this.$dayjs.duration(e.diff(s)).humanize()
    },
    timeToExpire (expire) {
      if (this.$dayjs() > this.$dayjs(expire)) return 0
      const s = this.$dayjs()
      const e = this.$dayjs(expire)
      return this.$dayjs.duration(e.diff(s)).humanize()
    },
    goDevices () {
      window.location.href = `/devices?license=${this.uuid}`
    },
    async getPublicKey () {
      const params = {
        url: `licenses/${this.uuid}/public_key`,
        method: 'FILE',
        params: {}
      }
      await request(params).then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', 'publickey.pub')
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    }
  },
  mounted () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Licenses')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Detail')
    this.$route.meta.pageTitle = this.$t('Path.Detail')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) 
        if (this.callFinish) 
          this.doFinish()
        else 
          this.getPublicKey()
    }
  }
}
</script>
